import { render, staticRenderFns } from "./SemesterCrud.vue?vue&type=template&id=52db33ac&scoped=true"
import script from "./SemesterCrud.vue?vue&type=script&lang=js"
export * from "./SemesterCrud.vue?vue&type=script&lang=js"
import style0 from "./SemesterCrud.vue?vue&type=style&index=0&id=52db33ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db33ac",
  null
  
)

export default component.exports